export default __webpack_public_path__ + "static/media/monterossa.c4334907.png";